import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const WhatsAppFloat = () => {
  const { waLink } = useSettings();
  return (
    <motion.a
      data-testid="whatsapp-float-button"
      href={waLink("Halo Salon Strawberry Official! Saya ingin booking appointment.")}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.5, type: "spring", stiffness: 200 }}
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-brand-burgundy text-brand-cream shadow-[0_8px_30px_rgba(74,14,23,0.4)] transition-transform duration-300 hover:scale-110"
      aria-label="Booking via WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-brand-gold/30 animate-ping [animation-duration:2.5s]" />
      <MessageCircle size={24} className="relative" />
    </motion.a>
  );
};
